"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = css;
exports.n = n;
exports.px = px;
exports.pxn = pxn;
exports.remove = _remove;
exports.testStyleName = exports.test = void 0;
exports.url = url;

var _is = require("./is.js");

var _object = require("./object.js");

// 值,防止值太小时,转换成字符串使用指数表示法
function n(v) {
  return Math.round(v * 10000) / 10000;
} // 处理长度


function px(value) {
  return (0, _is.isNumber)(value) ? value === 0 ? 0 : "".concat(Math.round(n(value)), "px") : value;
} // 有小数点的长度


function pxn(value) {
  return "".concat(n(value), "px");
}

function url(value) {
  return "url(".concat(JSON.stringify(value), ")");
} // 移除CSS值,可以移除一条,或者移除一组


function _remove(el, arg) {
  function removeStyle(styleName) {
    ['', '-webkit-', '-ms-', '-moz-', '-o-'].forEach(function (prefix) {
      el.style.removeProperty(prefix + styleName);
    });
  }

  (0, _is.isString)(arg) ? removeStyle(arg) : (0, _is.isObject)(arg) ? Object.keys(arg).forEach(removeStyle) : arg.forEach(removeStyle);
  return el;
} // region css
// 测试某个样式是否有效


var test = function () {
  if (window.CSS && CSS.supports) {
    return function (styleName, styleValue) {
      return CSS.supports(styleName, styleValue);
    };
  }

  var testElement = document.createElement('div');
  return function (styleName, styleValue) {
    testElement.removeAttribute('style');
    testElement.style.setProperty(styleName, styleValue, '');
    return testElement.hasAttribute('style');
  };
}();

exports.test = test;

function testPrefix(styleName, styleValue) {
  return ['', '-webkit-', '-ms-', '-moz-', '-o-'].find(function (prefix) {
    return test(prefix + styleName, styleValue);
  });
} // 测试某个样式的样式名(找前缀)


var testStyleName = function () {
  var prefix = '';
  return function (styleName, styleValue) {
    if (styleValue) {
      styleValue = styleValue.replace(/!important/gi, '');
    }

    var retVal = (test(styleName, styleValue) ? '' : prefix ? test(prefix + styleName, styleValue) ? prefix : '' : prefix = testPrefix(styleName, styleValue)) + styleName;
    return retVal;
  };
}(); // 设置样式


exports.testStyleName = testStyleName;

function css(el, arg1, arg2) {
  function setStyle(styleValue, styleName) {
    if (styleValue == null) {
      _remove(el, styleName);
    } else {
      styleValue += '';

      if ((0, _is.isNumber)(styleValue)) {
        styleValue = n(styleValue);
      }

      el.style.setProperty(testStyleName(styleName, styleValue), styleValue, '');
    }
  }

  (0, _is.isString)(arg1) ? setStyle(arg2, arg1) : (0, _object.forOwn)(arg1, setStyle);
  return {
    element: el,
    remove: function remove() {
      _remove(el, arg1);
    }
  };
}